import { createSlice } from '@reduxjs/toolkit';
import { THEME_CONFIG } from '../../configs/theme-config';

const LOCAL_LANGUAGES = [
  { id: 1, locale: 'en', title: 'English', default: true },
  { id: 2, locale: 'de', title: 'Deutsch', default: false },
  { id: 3, locale: 'it', title: 'Italiano', default: false },
  { id: 4, locale: 'fr', title: 'Francais', default: false },
];

const initialState = {
  languages: LOCAL_LANGUAGES,
  defaultLang: THEME_CONFIG.locale,
};

const FormLang = createSlice({
  name: 'formLang',
  initialState,
  reducers: {
    setLangugages(state, action) {
      state.languages = action.payload;
    },
    clearLangugages(state, action) {
      state.languages = [];
    },
    setDefaultLanguage(state, action) {
      state.defaultLang = action.payload;
    },
  },
});

export const { setLangugages, setDefaultLanguage, clearLangugages } =
  FormLang.actions;
export default FormLang.reducer;
